import { Link } from "react-router-dom";
import FormBuilder from "../../common/components/formInputs/FormBuilder";
import { validatePassword } from "../../common/helpers/common";

const validateConfirmPassword = (value, password) => {
  return value === password || "Passwords do not match";
};

function getFormInputs() {
  return [
    {
      type: "password",
      name: "password",
      label: "Password",
      placeholder: "Enter at least 8 characters",
      validation: {
        required: "Password is required",
        validate: validatePassword,
      },
    },
    {
      type: "password",
      name: "confirmPassword",
      label: "Confirm Password",
      placeholder: "Confirm Password",
      validation: {
        required: "Confirm Password is required",
        validate: (value, otherValues) => {
          return validateConfirmPassword(value, otherValues.password);
        },
      },
    },
  ];
}

function VerifySignupForm({ onSubmit, isSubmitting }) {
  return (
    <div className="text-gray-700 md:10/12 lg:w-7/12">
      <div className="font-bold text-center my-2 mb-4 text-2xl font-bold">
        Create Password
      </div>

      <FormBuilder
        formInputs={getFormInputs()}
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
      />

      <div className="flex justify-center items-center space-x-2 text-gray-500 pb-2">
        <div>Go to</div>

        <div>
          <Link to="/login" className="back_link underline">
            Login
          </Link>
        </div>
        <div>or</div>
        <div>
          <Link to="/signup" className="back_link underline">
            Sign Up
          </Link>
        </div>
      </div>
    </div>
  );
}

export default VerifySignupForm;
